import React, { useEffect, useState } from "react";
import { Typography, CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Alert } from "@material-ui/lab";
import { find } from "lodash";

import "./style.css";
import { api_root, downloadImage, request } from "../requests";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const Players = ({ selectedPlayer, setSelectedPlayer }) => {
  const location = useLocation();
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [images, setImages] = useState({});

  const history = useHistory();
  const goToAssets = (id_player) => {
    const { statusIsOnline } = find(players, ({ id }) => id === id_player);
    if (statusIsOnline) {
      history.push({ pathname: "/assets", search: `?id=${id_player}` });
      setSelectedPlayer(id_player);
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    setSelectedPlayer(urlParams.get("id"));
  }, [location, setSelectedPlayer]);

  useEffect(() => {
    setLoading(true);
    request({
      type: "devices",
      method: "get",
    })
      .then(({ data, error }) => {
        setLoading(false);
        if (!error && data) {
          setPlayers(data);
        }
      })
      .catch(({ message }) => {
        setError(message);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const promises = [];
    const data = {};
    players.forEach(({ screenshot, id }) => {
      promises.push(
        new Promise((resolve) => {
          downloadImage(
            `${api_root}/devices/${id}/thumbnail?${screenshot}`
          ).then((image) => {
            data[id] = image;
            resolve();
          });
        })
      );
    });
    Promise.all(promises).then(() => {
      setImages(data);
    });
  }, [players]);

  return (
    <div className="Players">
      <Typography variant="h4">Players</Typography>
      {error && <Alert severity="error">{error}</Alert>}
      {loading && (
        <center>
          <CircularProgress />
        </center>
      )}
      {!loading && (
        <div className="container">
          {players.map(({ name, id, statusIsOnline }) => (
            <div
              className={`player ${selectedPlayer === id ? "selected" : ""} ${
                !statusIsOnline ? "disabled" : ""
              }`}
              key={`player${id}`}
              onClick={goToAssets.bind(this, id)}
            >
              <div
                className="thumbnail"
                style={{
                  backgroundImage: `url(data:image/png;base64,${images[id]})`,
                }}
              />
              <div className="name">{name}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Players;
